/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCommissionStatementDto, serializeReturnToReviewRequest, type CommissionStatementDto, type ErrorResponse, type InternalErrorResponse, type ReturnToReviewRequest } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/{commissionStatementId}/return-to-review
 */
export interface ReturnToReviewRequestBuilder extends BaseRequestBuilder<ReturnToReviewRequestBuilder> {
    /**
     * Moves a statement from Disputed back to InReview once the dispute has been dealt with, putting it back in front of a reviewer to approve or dispute again. This is the only way out of Disputed: a disputed statement cannot be approved or marked paid directly. It applies only to a disputed statement — a Pending one is submitted for review instead. The dispute and its reason stay in the history, and the amounts are unchanged, so a dispute that was actually about the figures needs a fresh statement rather than this. `user` is required and is recorded against the change.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ReturnToReviewRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Moves a statement from Disputed back to InReview once the dispute has been dealt with, putting it back in front of a reviewer to approve or dispute again. This is the only way out of Disputed: a disputed statement cannot be approved or marked paid directly. It applies only to a disputed statement — a Pending one is submitted for review instead. The dispute and its reason stay in the history, and the amounts are unchanged, so a dispute that was actually about the figures needs a fresh statement rather than this. `user` is required and is recorded against the change.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ReturnToReviewRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReturnToReviewRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/{commissionStatementId}/return-to-review";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReturnToReviewRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ReturnToReviewRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReturnToReviewRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
